export default __webpack_public_path__ + "static/media/twoj-dom.af2cfe72.png";